import { Col, Container, Row } from "react-bootstrap";
import Main from "../Main/Main";

const Header = ({ marca, listado, title }) => {
  return (
    <Container fluid>
      <Row>
        <Container>
          <Row>
            <Col
              md={6}
              className={`header mx-auto d-flex justify-content-center align-items-center align-content-center flex-column   ${marca}`}
              xs={12}
            >
              <div className={`redondeado ${marca}`}>
                <Main marca={marca} listado={listado} title={title} />
              </div>
            </Col>
          </Row>
        </Container>
      </Row>
    </Container>
  );
};

export default Header;
